import { Injectable } from '@angular/core';
import { filter, Observable, switchMap, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { SpecialPrice, LocalChannel, Store as StoreModel } from '@core/models';
import { environment } from '@environments/environment';
import { IResponseSuccess } from '@core/interfaces';
import { selectSpecialPrice, selectSpecialPriceList, selectLocalChannel, selectStore } from '@store/selectors';

@Injectable({
	providedIn: 'root',
})
export class SpecialPriceService {
	specialPrice$: Observable<SpecialPrice | null>;
	specialPriceList$: Observable<SpecialPrice[] | null>;
	localChannelList$: Observable<LocalChannel[] | null>;
	store$: Observable<StoreModel | null>;

	constructor(
		private http: HttpClient,
		private store: Store<AppState>
	) {
		this.specialPrice$ = this.store.select(selectSpecialPrice);
		this.specialPriceList$ = this.store.select(selectSpecialPriceList);
		this.localChannelList$ = this.store.select(selectLocalChannel);
		this.store$ = this.store.select(selectStore);
	}

	findAll(): Observable<IResponseSuccess<SpecialPrice>> {
		return this.store$.pipe(
			filter((store): store is StoreModel => !!store),
			switchMap(store => {
				return this.http.get<IResponseSuccess<SpecialPrice>>(`${environment.microPerk}/precio-especial`, {
					headers: {
						authorization: store.apiKey,
					},
					params: {
						localId: store.idLocal,
					},
				});
			}),
			take(1)
		);
	}
}
